import { connect } from "react-redux";

import PlatformSwitcher from "./PlatformSwitcher";

import { mapStateToProps } from "./PlatformSwitcherMapper";

export default connect(mapStateToProps, null)(PlatformSwitcher);
